import { ReactElement } from 'react';
import { BlockType } from '../../../../../../../../utils/preview/preview-height-calculator';
import MaterialImage from '../../../../components/material-image/material-image';
import handleLinkClick from '../../../../utils/handle-link-click';
import './left-aside.scss';

type LeftAsideProps = { item: Material; index: number; imageSize: BlockType; internalPath?: string };

const LeftAside = (props: LeftAsideProps): ReactElement => {
    const { item, index } = props;

    const onImageClick = (): void => handleLinkClick({ item, index });

    return (
        <aside className='left-aside'>
            <MaterialImage {...props} onClick={onImageClick} />
        </aside>
    );
};

export default LeftAside;
